import { eventTrackExtra } from "@/apis/gameJump";
export default {
  methods: {
    isAndroid() {
      let u = navigator.userAgent;
      return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    },
    buryReport(type, extra_data) {
      const { appkey, user_id, ...rest } = extra_data
      eventTrackExtra({
        appkey: appkey || '0',
        event: type,
        device_id: "null",
        device_name: "null",
        system_version: "null",
        extra_data: JSON.stringify({
          ...rest,
        }),
        user_id: user_id || 'null',
        os: this.isAndroid() ? "android" : "ios",
        client_extra_data: JSON.stringify({
          os: this.isAndroid() ? "android" : "ios",
          jh_channel: "null",
        }),
      });
    },
  },
}
